import { API } from './interceptor'

export const notifyCustomRolesPaywallSales = ({
  venueId,
  source = 'client',
  platform = 'dashboard',
  roleName = null,
}) => {
  if (!venueId) {
    return Promise.resolve()
  }

  return API.post('api2', `venue/${venueId}/custom-roles-paywall-notify`, {
    body: {
      source,
      platform,
      roleName,
    },
  }).catch(() => {
    // Fire-and-forget; paywall UX must not depend on sales notify
  })
}
